import React from "react";
import { Card, Container, Row, Col, Badge, Button } from "react-bootstrap";
import { FiArrowRight } from "react-icons/fi";
import { navigationActions } from "../actions/navigationActions";
import "./component.css";
import { useIntl } from "react-intl";
import { SemiDonutChart } from "./SemiDonutChart";
import policlinicoImg from "../assets/images/hp-card-segui-paziente.jpg";

export const BodyHomePage = ({
  hospitalStatus,
  history,
  dispatch,
  nedocsValue
}) => {
  const intl = useIntl();

  const summaryStatusAccordion = {
    badgeContent: [
      {
        backgroundColorBadge: "#eb3852",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceRosso' }),
        personeAttesa: intl.formatMessage({ id: 'homePage.inAttesa' }),
        total: hospitalStatus.status.summaryStatus.totalRed,
        waiting: hospitalStatus.status.summaryStatus.waitingRed
      },
      {
        backgroundColorBadge: "rgb(246, 182, 56)",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceArancione' }),
        personeAttesa: intl.formatMessage({ id: 'homePage.inAttesa' }),
        total: hospitalStatus.status.summaryStatus.totalOrange,
        waiting: hospitalStatus.status.summaryStatus.waitingOrange
      },
      {
        backgroundColorBadge: "#00b4f8",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceBlu' }),
        personeAttesa: intl.formatMessage({ id: 'homePage.inAttesa' }),
        total: hospitalStatus.status.summaryStatus.totalBlue,
        waiting: hospitalStatus.status.summaryStatus.waitingBlue
      },
      {
        backgroundColorBadge: "#56c965",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceVerde' }),
        personeAttesa: intl.formatMessage({ id: 'homePage.inAttesa' }),
        total: hospitalStatus.status.summaryStatus.totalGreen,
        waiting: hospitalStatus.status.summaryStatus.waitingGreen
      },
      {
        backgroundColorBadge: "none",
        textColorBadge: "black",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceBianco' }),
        personeAttesa: intl.formatMessage({ id: 'homePage.inAttesa' }),
        total: hospitalStatus.status.summaryStatus.totalWhite,
        waiting: hospitalStatus.status.summaryStatus.waitingWhite
      }
    ]
  };

  const HospitalStateComp = () => {
    return (
      <Card
        className="shadow border-0 text-dark border-card"
        style={{ padding: "2%", cursor: "pointer" }}
        onClick={() => {
          history.push("/status");
          navigationActions.changeNavigation(
            "/status",
            dispatch
          );
        }}
      >
        <Row className="p-1">
          <Col md={8} sm={8} xs={8}>
            <Card.Title style={{ fontSize: "90%" }}>
              <b>{intl.formatMessage({ id: 'homePage.statusProntoSoccorso' })}</b>
            </Card.Title>
            <Card.Text style={{ fontSize: "60%" }}>
              {intl.formatMessage({ id: 'homePage.attualeIndiceAffollamento' })}
            </Card.Text>
          </Col>
          <Col md={4} sm={4} xs={4}>
            <div>
              <SemiDonutChart percentage={nedocsValue > 0 ? nedocsValue : 0} percentageColor={"#000"} />
            </div>
          </Col>
        </Row>
        <Row
          className="p-1 align-items-center"
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          {summaryStatusAccordion.badgeContent.map((element, index) => (
            <Card
              key={index.toString()}
              className="text-dark border-card "
              style={{
                backgroundColor: "rgba(0,0,0,.0)",
                width: "20%",
                borderTop: 0,
                borderBottom: 0
              }}
            >
              <div className="text-center" style={{ fontSize: "55%" }}>
                <b className="capitalize">{element.coloreCodice}</b>
              </div>

              <div className="text-center" style={{ marginTop: "1%", fontSize: "50%" }}>
                &nbsp;{element.personeAttesa}{" "}
              </div>

              <Card
                className=" align-items-center border-0"
                style={{
                  minWidth: "min-content",
                  marginTop: "15%",
                  marginBottom: "15%"
                }}
              >
                <Card>
                  <Badge
                    style={{
                      backgroundColor: element.backgroundColorBadge,
                      fontSize: "100%",
                      color: element.textColorBadge
                    }}
                  >
                    {element.waiting}
                  </Badge>
                </Card>
              </Card>

              <div className="text-center" style={{ fontSize: "50%" }}>
                <b style={{ fontSize: "130%", color: "#727272" }}>+{element.total - element.waiting}</b>
                <div>{intl.formatMessage({ id: 'homePage.inTrattamento' })}</div>
              </div>
            </Card>
          ))}
        </Row>
      </Card>
    )
  }

  const ServiceComp = () => {
    return (
      <Card className="border-0 text-dark border-card m-3">
        <Card.Img
          className="shadow"
          src={policlinicoImg}
          alt="Card image"
          style={{
            maxHeight: "280px",
            objectFit: 'cover',
          }}
        />
        <Button
          className="text-white border-0 btn-lg button-message"
          onClick={() => {
            history.push("/monitoraggio");
            navigationActions.changeNavigation(
              "/monitoraggio",
              dispatch
            );
          }}
          style={{
            marginTop: "-2em",
            marginLeft: "auto",
            marginRight: "2em",
            width: "50%",
            borderRadius: 0,
            backgroundColor: "#00215B",
          }}
        >
          <span className="font-weight-bold">
            {intl.formatMessage({ id: 'homePage.monitoraggioPaziente' })}{" "}
          </span>
          <FiArrowRight
            className="button-arrow"
            style={{ fontSize: "1.4em" }}
          />
        </Button>
      </Card>
    )
  }

  return (
    <>
      <Container>
        <Row>
          <Col>
            <br />
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center">
          <Col md={{ span: 6, order: 2 }}
            lg={{ span: 6, order: 2 }}
            sm={{ span: 12, order: 2 }}
            xs={{ span: 12, order: 2 }} >
            <HospitalStateComp />
          </Col>
          <Col md={{ span: 6, order: 2 }}
            lg={{ span: 6, order: 2 }}
            sm={{ span: 12, order: 1 }}
            xs={{ span: 12, order: 1 }}
            style={{ paddingTop: '12px' }}
          >
            <ServiceComp />
          </Col>
        </Row>
        {/*         <Row>
          <Col>
            <b className="border-card">
              {intl.formatMessage({ id: 'homePage.altriServizi' })}
            </b>
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center">
          <Col md={4} lg={4} sm={12} xs={12}>
            {ServiceComp()}
          </Col>
          <Col md={4} lg={4} sm={12} xs={12}>
            {ServiceComp()}
          </Col>
          <Col md={4} lg={4} sm={12} xs={12}>
            {ServiceComp()}
          </Col>
        </Row> */}
      </Container>
    </>
  );
};
